/** Highlight application placeholders while preserving selectable plain text. */
export function AnswerText({ text }: { text: string }) {
  return <>{text.split(/(\[[^\[\]\r\n]+\])/g).map((part, index) =>
    index % 2 === 1 ? <span className="answer-placeholder" key={index}>{part}</span> : part,
  )}</>
}
